import { createContext, useState } from "react";

const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
    const [auth, setAuth] = useState({});
    const[splashModal, setSplashModal] = useState(true)

    return (
        <AuthContext.Provider value={{ auth, setAuth, splashModal, setSplashModal }}>
            {children}
        </AuthContext.Provider>
    )
}

export default AuthContext;